export function formatScorecardPercentile(value: number): string {
  const percentile = Math.abs(value) <= 1 ? value * 100 : value;
  const rounded = Math.round(percentile);
  const lastTwo = Math.abs(rounded) % 100;
  if (lastTwo >= 11 && lastTwo <= 13) return `${rounded}th`;
  const suffix =
    Math.abs(rounded) % 10 === 1
      ? 'st'
      : Math.abs(rounded) % 10 === 2
        ? 'nd'
        : Math.abs(rounded) % 10 === 3
          ? 'rd'
          : 'th';
  return `${rounded}${suffix}`;
}

export function formatScorecardAxisPercentile(value: number): string {
  const percentile = Math.abs(value) <= 1 ? value * 100 : value;
  if (Math.abs(percentile) < 10) return `${percentile.toFixed(1)} percentile`;
  return `${formatScorecardPercentile(value)} percentile`;
}
